import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Header from "./header/Header";
import PageLoader from "./pageLoader/PageLoader";
import CreateTeamPage from "../createTeam/CreateTeamPage";
import MoveTeamPage from "../moveTeam/MoveTeamPage";
import TeamSubheader from "./subheader/TeamSubheader";
import JobsPageWrapper from "../myjobs/JobsPageWrapper";

const Content: React.FC = (): JSX.Element => {
  return (
    <React.Fragment>
      <Header />
      <PageLoader>
        <Switch>
          <Redirect exact from="/" to="/team/amazon" />
          <Route
            path="/team/:parentTeamId/createTeam"
            component={CreateTeamPage}
          />
          <Route path="/team/:teamId/moveTeam" component={MoveTeamPage} />
          <Route path="/team/:teamId" component={TeamSubheader} />
          <Route path="/system-tasks" component={JobsPageWrapper} />
        </Switch>
      </PageLoader>
    </React.Fragment>
  );
};

export default Content;
